define('vspot-angular/services/organization-service',[], function () {
    'use strict';

    return ['resources.Organization', function (Organization) {
        return {
            /*
             * Get a list of all the organizations that the current user is a member of.
             */
            query: function () {
                return Organization.query();
            },
            queryByUser: function () {
                // uses session user id
                return Organization.query({ owner: true });
            },
            /*
             * Get a single organization.
             */
            get: function (orgId) {
                return Organization.get({ id: orgId });
            },

            delete: function (orgId) {
                return Organization.delete({ id: orgId });
            },

            /**
             * Retrieve a list of users for the organization.
             * @param {int} orgId ID of the ogranization.
             */
            showOrganizationalUsers: function (orgId) {
                return Organization.showOrganizationalUsers({
                    organization_id: orgId
                });
            },

            /**
             * Delete users from the organization.
             * @param {int} orgId ID of the organization.
             * @param {arr} userArray Array of user ID's to remove from the organization.
             */
            deleteOrganizationalUsers: function (orgId, userArray) {
                return Organization.deleteOrganizationalUsers({
                    organization_id:            orgId,
                    organizational_user_ids:    userArray
                });
            },

            /**
             * Show all the activities that are members of shared groups within that organization.
             * @param {int} orgId ID of the ogranization.
             */
            showOrganizationalActivities: function (orgId) {
                return Organization.showOrganizationalActivities({
                    organization_id: orgId
                });
            },

            /**
             * Copy an activity that is included within a group that is shared within an organization to the organization's owner.
             * @param {int} activityId ID of the activity to copy.
             * @param {str} name The name of the new activity - if you name it the same name as an activity that you already own, you will get a warning.
             * @param {str} startDate The date the new activity should start in the format of YYYY/MM/DD
             * @param {bool} includePast Include past dates when copying events on this activity
             * @param {bool} force False by default. True to override the warning when a user copies an activity to one that already has the same name.
             */
            copyActivity: function (activityId, name, startDate, includePast, force) {
                return Organization.copyActivity({
                    selected_activity:  activityId,
                    new_activity_name:  name,
                    new_start_date:     startDate,
                    include_past:       includePast,
                    force:              force === true ? true : false // default to false if not explicitly true
                });
            },

            /**
             * Show all volunteers in quick search
             */
            showAllMyVolunteers: function() {
                return Organization.showAllMyVolunteers();
            },

            /**
             * Show volunteer job details in quick search
             */
            showMyVolunteer: function (volEmail) {
                return Organization.showMyVolunteer({
                    email: volEmail
                });
            }
        };
    }];
});

